export const TOAST_MESSAGE_PREFS_TAG_NAME = 'uam/pub/toastMessagePreferences';

export enum AGE_VERIFICATION_STATUS {
    FAILED = 'failed',
    REVIEW = 'review',
    UNKNOWN = 'unknown',
    PASSED = 'passed',
    ACTIVE_GRACE_PERIOD = 'inprocess'
}

export enum ID_COPY_FAX_VERIFICATION_STATUS {
    NOT_VERIFIED = '0',
    VERIFIED = '1'
}

export const VERIFIED_STATUS = 'verified';
